import thunkMiddleware from 'redux-thunk';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { setEndpointHost, setEndpointPath, setHeader, setAccessToken } from 'redux-json-api';
import { composeWithDevTools } from 'redux-devtools-extension';
import { PathHelper } from '../util/UrlUtil';

export const baseEndpointPath = 'api/data';

const defaultStoreSetup = (reducers, initialState) => {
  const reducer = combineReducers(reducers);
  const composedStore = composeWithDevTools({ trace: true });
  const enhancer = composedStore(applyMiddleware(thunkMiddleware));
  return createStore(reducer, initialState, enhancer);
};

export const genericStoreSetup = (reducers, initialState) => {
  const store = defaultStoreSetup(reducers, initialState);
  store.dispatch(setEndpointHost('/'));
  store.dispatch(setEndpointPath(baseEndpointPath));

  try {
    const authToken = document.querySelector('meta[name=csrf-token]').attributes.content.value;
    store.dispatch(setHeader({ "X-CSRF-Token": authToken }));
  } catch (e) {
    /* istanbul ignore next */
    console.debug('Could not find csrf token meta tag');
  }
  store.dispatch(setHeader({ "Content-Type": 'application/vnd.api+json' }));

  return store;
};

export const externalStoreSetup = (reducers, initialState, endpointHost, endpointPath, accessToken) => {
  const store = defaultStoreSetup(reducers, initialState);
  let host = PathHelper.ensureEndSlash(endpointHost);
  let path = PathHelper.ensureNoEndSlash(endpointPath);
  path = PathHelper.ensureNoStartSlash(path);

  store.dispatch(setEndpointHost(host));
  store.dispatch(setEndpointPath(path));
  store.dispatch(setAccessToken(accessToken));
  store.dispatch(setHeader({ "Content-Type": "application/json" }));
  return store;
};
